import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useNavigateNext from '../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../hooks/useUpdateReportDoc'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import useHandleError from '../../../hooks/useHandleError'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useClinicalObservationsState } from './hooks/useClinicalObservationsState'
import { JournalInstructions } from './components/JournalInstructions'
import { ProgressValidation } from './components/ProgressValidation'
import { JournalTextarea } from './components/JournalTextarea'
import IncidentSection from './components/IncidentSection'

export const ClinicalObservationsPage = () => {
  const isValidated = useReportMonthGuard()
  const {
    clinicalObservations,
    setClinicalObservations,
    isValid,
    incidents,
    setIncidents,
  } = useClinicalObservationsState()
  const updateReport = useUpdateReportDoc()
  const navNext = useNavigateNext()
  const purpleBubbleContent = usePurpleBubblesText('Step-6')
  const handleError = useHandleError()

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        if (isValid) {
          updateReport({ clinicalObservations, incidents })
          navNext()
        } else {
          handleError('You must write a minimum of one sentence per month.')
        }
      }}
    >
      <Stack spacing={4}>
        <MonthlyReportHeader title='Journal - Clinical Observations' />
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}
        <JournalInstructions />
        <IncidentSection value={incidents} onChange={setIncidents} />
        <ProgressValidation
          clinicalObservations={clinicalObservations}
          isValid={isValid}
        />
        <JournalTextarea
          clinicalObservations={clinicalObservations}
          setClinicalObservations={setClinicalObservations}
        />
        <MonthlyReportNavButtons />
      </Stack>
    </form>
  )
}
